import { Button } from "@material-ui/core"
import { get } from "lodash"
import { makeStyles } from "@material-ui/core/styles"
import Avatar from "@material-ui/core/Avatar"
import Box from "@material-ui/core/Box"
import CommaPrice from "src/features/Utils/CommaPrice"
import Divider from "@material-ui/core/Divider"
import Grid from "@material-ui/core/Grid"
import React from "react"
import Typography from "@material-ui/core/Typography"
import QuantityModal from "../QuantityModal"

import NoImage from "src/assets/no-image.jpg"

const useStyles = makeStyles((theme) => ({
  avatar: { width: 67, height: 67 },
}))

export default ({ item, action, inCart }) => {
  const classes = useStyles()
  return (
    <Box>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={1}>
          <Avatar
            src={get(item, "cover_img") || NoImage}
            variant="rounded"
            className={classes.avatar}
          />
        </Grid>
        <Grid item xs={3}>
          <Box>{get(item, "presentation.search_name")}</Box>
          <Box color="text.secondary">
            {get(
              item,
              "presentation.registration_number.register_as.generics",
              []
            )
              .map((item) => item.name + " " + item.strength)
              .join(", ")}
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box>{get(item, "barcode")}</Box>
        </Grid>
        <Grid item xs={2}>
          <Box>{`${item.multiplier} ${item.presentation.presentation_name.name} x ${item.presentation.quantity} ${item.presentation.presentation_unit.name} / ${item.container.name}`}</Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            display="flex"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <Typography color={get(item, "is_promo") ? "primary" : "initial"}>
              {CommaPrice(
                get(item, "is_promo")
                  ? get(item, "promo_price")
                  : get(item, "price")
              )}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Box
            display="flex"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <QuantityModal
              onConfirm={(amount) => action(amount)}
              defaultQty={get(inCart, "amount")}
            >
              <Button color="secondary">
                {!!inCart ? "UPDATE" : "CHOOSE"}
              </Button>
            </QuantityModal>
          </Box>
        </Grid>
      </Grid>
      <Box mt={1} mb={1}>
        <Divider />
      </Box>
    </Box>
  )
}
